
import React from "react";
import Compound from "../Compound";
import { i18nManager } from "../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Utils } from "../../utils";
import LoadingGif from "../../assets/images/loading_circle.gif";
import { AuthService, IProfile, SanitizedResponse } from "../../services";

// http://localhost:3005/oauth?ref=https://suport.coparenting.com&bid=87328736762573527635762536
function Oauth() {
    const labels = i18nManager.Labels.oauth;
    const currentLocation = window.location.href;
    const navigate = ReactRouterDom.useNavigate();
    const authService = AuthService.getInstance();
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);
    const businessId = searchParams.get("bid");
    const referrer = searchParams.get("ref") ?? "/";
    const [referrerDomain, trustedDomainsSchemes, trustedSchemeBids] = Utils.extractTrustedDomainData(referrer);

    React.useEffect(() => {
        Debugger.log("Oauth:useEffect", currentLocation, trustedDomainsSchemes, referrerDomain);
        if (!searchParams.has("ref") || (!(referrerDomain in trustedDomainsSchemes) && !businessId)) {
            Utils.report(labels.ref_params_missing);
            Utils.postMessage("REDIRECT_BACK_TO_REFERRER", labels.ref_params_missing);
            navigate(-1);
            return;
        }
        const profiles = CacheManager.get(CacheManager.PROFILES_KEY) as IProfile[];
        if (!profiles?.length) {
            navigateToLogin();
            return;
        }
        fetchProfiles(profiles);
    }, []);

    return Compound({
        isOauth: true,
        processing: true,
        secondaryFormElement: (<div className="load-oauth">
            <img src={LoadingGif} alt={"validating account"} />
        </div>),
    });

    async function fetchProfiles(profiles: IProfile[]) {
        for (const profile of profiles) {
            fetchProfile(profile);
        }
    }

    async function fetchProfile(profile: IProfile, refreshSession: boolean = true) {
        authService.getProfile(profile.access_token).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("Oauth:fetchProfile:success", sanitized, "=>", trustedDomainsSchemes, "=>", referrerDomain, "=>", (referrerDomain in trustedDomainsSchemes),
                "<======>", trustedSchemeBids, "=>", trustedSchemeBids[trustedDomainsSchemes[referrerDomain]], "=>", businessId, "=>",
                trustedSchemeBids[trustedDomainsSchemes[referrerDomain]] === businessId);
            if (referrerDomain in trustedDomainsSchemes && trustedSchemeBids[trustedDomainsSchemes[referrerDomain]] === businessId) {
                const newProfile = { ...profile, ...sanitized,  };
                CacheManager.putProfile(newProfile);
                navigateForward(newProfile, {
                    external_id: businessId,
                    name: Utils.getReferrerFineName(trustedDomainsSchemes[referrerDomain], referrer),
                }, []);
                return;
            }
            // fetch business by ID using user id, and permissions using the keys
            navigateForward(sanitized, {
                external_id: businessId,
                tag_line: "Ronuse Inc.",
                logo_location: "https://avatars.githubusercontent.com/u/69908664?s=200&v=4",
                privacy_policy: "https://avatars.githubusercontent.com/u/69908664?s=200&v=4",
                term_of_service: "https://avatars.githubusercontent.com/u/69908664?s=200&v=4",
                name: Utils.getReferrerFineName(trustedDomainsSchemes[referrerDomain], referrer),
                description: "Ronuse  community is a place where every user from various platform can interact freely. It also help manages your online profile, automate posting to your profile, get more friends and expand your network.",
            }, [
                {
                    label: "View your complete profile data",
                    info: "Get your profile information like email, full name, phone number, address"
                },
                {
                    label: "Create and manage your timeline posts",
                    info: "Create and manage your timeline posts Get your profile information like email, full name, phone number, address"
                },
                {
                    label: "Create and manage your teams",
                    info: "So we are aligned Create and manage your teams"
                },
                {
                    label: "View and manage your tournaments",
                    info: "Create and manage your timeline posts and View and manage your tournaments"
                },
            ]);

        }).catch((error: SanitizedResponse<any>) => {
            Debugger.log("Oauth:fetchProfile:fail", error.status, error, refreshSession);
            if (refreshSession) {
                authService.refreshToken(profile.access_token, { access_token: profile.access_token, session_token: profile.session_token }).then(({ sanitized }: SanitizedResponse<any>) => {
                    Debugger.log("Oauth:fetchProfile:error:refresh:success", sanitized);
                    fetchProfile({ ...profile, ...sanitized }, false);
                }).catch((error: SanitizedResponse<any>) => {
                    Debugger.log("Oauth:fetchProfile:error:refresh:error", error);
                    navigateForward(profile, { name: referrer, }, []);
                });
                return;
            }
            navigateForward(profile, { name: referrer, }, []);
        });
    }

    async function navigateToLogin() {
        const querySearchParams: any = {
            rloc: `${window.location.origin}${window.location.pathname}?ref=${referrer}${businessId ? "&bid=" + businessId : ""}`,
        }; // lol
        if (searchParams.has("postonly")) querySearchParams.postonly = searchParams.get("postonly");
        navigate({
            pathname: "/",
            search: ReactRouterDom.createSearchParams(querySearchParams).toString(),
        }, { replace: true });
    }

    async function navigateForward(profile: any, business: any, permissions: any[]) {
        navigate("/oauth/select-account", {
            state: {
                profile,
                referrer,
                business,
                permissions,
                postOnly: searchParams.has("postonly"),
                isTrusted: (referrerDomain in trustedDomainsSchemes && trustedSchemeBids[trustedDomainsSchemes[referrerDomain]] === searchParams.get("bid")),
            }
        });
    }

}

export default Oauth;
